/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import StringCell from '../StringCell';

const RawHtmlCell = StringCell.extend({
  className: 'raw-html-cell',

  render() {
    this.$el.empty();
    const name = this.column && this.column.get && this.column.get('name');
    const raw = this.formatter ? this.formatter.toRaw(this.model.get(name), this.model) : this.model.get(name);
    this.$el.html(_.isNil(raw) ? '' : raw);
    return this;
  },
});

export default RawHtmlCell;
